import { Box, BoxProps, ColorOptions, Icon, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../../components/AdminInputs'
import { ButtonNew } from '../../../components/AdminButton'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { ModalAlertView } from '../../../components/ModalAlertView'
import { RootStore, useLazyApiData, useStores } from '../../../data/store'
import { MessageTypes } from '../../../utils'
import { Documentation } from '../Onboarding/Documentation'
import { styles } from '../styles'
import { Header } from './Comps/Header'
import AadharRedactionSubmit from './Maker/Submit'

const FormBox = ({ children }: any) => {
  return <Box {...styles.formContainer}>{children}</Box>
}
const rightComp = (isLoading: boolean) => {
  return (
    <Box w={100}>
      <ModBox show={isLoading} {...styles.loadingContainer}>
        <Loader type={'small'} color={'#A0A0A0' as ColorOptions} />
        <Spacer size={8} direction={'horizontal'} />
        <Text title={'Searching...'} color={'#A0A0A0' as ColorOptions} fontSize={12} fontFamily={'jiotype-medium'} />
      </ModBox>
    </Box>
  )
}

const Footer = ({ show, disabled, showConfirmationDialoig, onMakerCommentChange, makerComment }: any) => {
  const handleFooterPress = () => {
    showConfirmationDialoig(true)
  }

  if (!show) {
    return null
  }
  return (
    <Box {...styles.footerNonEntity} position={'sticky'}>
      <ModBox w={'60%'} marginTop={-24}>
        <TextInputNew
          label={"Maker's Comments"}
          color="BLACK_21"
          type="body12"
          borderColor={'#d1d3e2' as ColorOptions}
          labelPaddingBottom={10}
          borderRadius={4}
          labelFontFamily="jiotype-medium"
          labelColor={'#757575' as ColorOptions}
          fontSize={12}
          selectionColor={'BLUE'}
          paddingVertical={9}
          onFocusBorderWidth={1}
          value={makerComment}
          onChangeText={onMakerCommentChange}
          paddingHorizontal={8}
        />
      </ModBox>
      <ButtonNew
        onPress={handleFooterPress}
        title={'Submit changes for approval'}
        height={40}
        width={230}
        isLoading={false}
        disabled={disabled}
      />
    </Box>
  )
}
const AadharRedaction = () => {
  const {
    docsList,
    fetchDocuments,
    replaceDocument,
    editedDocs,
    undoAadharReplace,
    kycFetchUploadId,
    documentsLength,
    uploadId,
    setSideMenuRefresh,
    createUpdateDeleteFiuData,
    checkIfAnyDocumentsReplaced,
    resetUploadId,
  } = useStores((store) => ({
    docsList: store.getKycAadharDocumentsList(),
    fetchDocuments: store.getDocumentsList,
    replaceDocument: store.replaceAadharRedaction,
    editedDocs: store.getKycEditedAadharDocumentsList(),
    undoAadharReplace: store.undoAadharReplace,
    kycFetchUploadId: store.kycFetchUploadId,
    documentsLength: store.aadharRedactiondocuments.length,
    uploadId: store.onboarding.uploadId,
    setSideMenuRefresh: store.setSideMenuRefresh,
    createUpdateDeleteFiuData: store?.createUpdateDeleteFiuData,
    checkIfAnyDocumentsReplaced: store?.checkIfAnyDocumentsReplaced,
    resetUploadId: store?.onboarding?.resetUploadId,
  }))
  // const [showUploadModal, setShowUploadModal] = useState(false)
  // const [selectedDocument, setSelectedDocument] = useState(false)
  const [showList, setShowList] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [mid, setMid] = useState('')
  // const [listCalled, setListCalled] = useState(false)
  const [headerData, setHeaderData] = useState({
    id: '',
  })
  const [showCreatedScreen, setShowCreatedScreen] = useState(false)
  const [applicationId, setApplicationId] = useState('')
  const [makerComments, setMakerComments] = useState('')
  const [backPressed, setBackPressed] = useState(false)
  const [fetchDocumentList, fetchDocumentListHandler] = useLazyApiData(fetchDocuments)
  // const [fetchKycUploadId, uploadIdHandler] = useLazyApiData(kycFetchUploadId)
  const [createWorkItem, createWorkItemHandler] = useLazyApiData(createUpdateDeleteFiuData)

  const regex = /^\d{15}$/
  const isValidMid = mid.length === 15 && regex.test(mid)
  const navigation = useNavigation()

  useEffect(() => {
    if (fetchDocumentListHandler?.state === 'fulfilled' && !showList && !backPressed) {
      setShowList(true)
    }
    resetUploadId()
  }, [backPressed, fetchDocumentListHandler?.state, resetUploadId, showList])

  useEffect(() => {
    if (
      createWorkItemHandler?.state === 'fulfilled' &&
      createWorkItemHandler?.data?.data?.status?.toLowerCase() === 'success'
    ) {
      setShowCreatedScreen(true)
      setApplicationId(createWorkItemHandler?.data?.data?.applicationId)
    }
  }, [createWorkItemHandler?.data?.data, createWorkItemHandler?.state])

  // const onUpdateUploadedExcelFile = (data: any) => {
  //   if (documentsLength > 0) {
  //     // isValidToProceed(true)
  //   }
  //   if (data) {
  //     // setShowDocViewModal(false)
  //   }
  //   if (!listCalled) {
  //     setListCalled(true)
  //     fetchKycDocsList(uploadId)
  //     setTimeout(() => {
  //       setShowUploadModal(false)
  //     }, 1000)
  //   }
  // }

  // const onUpdateFileName = (_fileName: any) => {}

  const onSearchPress = () => {
    if (isValidMid) {
      // fetchKycUploadId(mid, true)
      setBackPressed(false)
      fetchDocumentList(mid, true, false, 'AADHAR_REDACTION')
      setHeaderData({ id: mid, ...headerData })
    } else {
      RootStore.message.setMessage('Enter valid MID to search', MessageTypes.ERROR)
    }
  }

  const isValidToProceed = (isValid: boolean) => {
    console.log('isValidToProceed enable submit button', isValid)
  }
  const onHandleBack = () => {
    setShowList(false)
    setBackPressed(true)
  }
  const showConfirmationDialoig = () => {
    setShowConfirmation(true)
  }

  const handleSubmit = () => {
    //call api
    createWorkItem(mid, 'AADHAR_REDACTION', uploadId, makerComments)
  }

  const handleParentBack = () => {
    setShowCreatedScreen(false)
  }

  const onMakerCommentChange = (comment: string) => {
    setMakerComments(comment)
  }
  return (
    <>
      <ModBox show={!showCreatedScreen} {...styles.container} marginBottom={32}>
        <Spacer size={16} direction={'horizontal'} />
        <ModBox {...styles.header} show={!showList}>
          <Text title={'Aadhaar Redaction '} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        </ModBox>
        <ModBox show={showList}>
          <Header
            from={'aadharRedaction'}
            navigation={navigation}
            setSideMenuRefresh={setSideMenuRefresh}
            applicationId={mid}
            headerData={headerData}
            handleBackFromParent={onHandleBack}
          />
        </ModBox>
        <ModBox {...mStyles.innerContainer} show={!showList}>
          <Box {...mStyles.searchContainer}>
            <Text title={'Search for a merchant'} fontSize={14} color={'BLACK_21'} fontFamily={'jiotype-bold'} />
            <Spacer direction="vertical" size={24} />
            <Box {...mStyles.textInputContainer(false)}>
              <TextInputNew
                placeholder="Search with an MID"
                paddingVertical={13}
                paddingHorizontal={16}
                value={mid}
                maxLength={15}
                onChangeText={(text) => setMid(text)}
                focusBorderColor={'TRANSPARENT'}
                rightComponent={rightComp(fetchDocumentListHandler?.state === 'pending')}
              />
              <ModBox onPress={onSearchPress} {...mStyles.iconContainer(isValidMid)}>
                <Icon
                  id={fetchDocumentListHandler?.state === 'pending' ? 'CLOSE' : 'SEARCH'}
                  color={'WHITE'}
                  size={20}
                />
              </ModBox>
            </Box>
          </Box>
        </ModBox>
        <ModBox show={showList} h={'90%'}>
          <Documentation
            type={'AD_MAKER'}
            isValidToProceed={isValidToProceed}
            selectedEntity={isValidMid ? { id: mid } : {}}
            showTitle={false}
          />
          <Footer
            show={true}
            disabled={!checkIfAnyDocumentsReplaced()}
            showConfirmationDialoig={showConfirmationDialoig}
            makerComment={makerComments}
            onMakerCommentChange={onMakerCommentChange}
          />
        </ModBox>
        <ModalAlertView
          message="Are you sure you want to submit changes for approval?"
          show={showConfirmation}
          showHeader={false}
          title={''}
          buttonTitle={'Submit changes for approval'}
          cancelTitle={'Go Back'}
          onDismiss={() => setShowConfirmation(false)}
          onPress={() => [setShowConfirmation(false), handleSubmit()]}
          onCancel={() => setShowConfirmation(false)}
          positiveButtonColor={'PRIMARY'}
          cancelButtonColor={'WHITE'}
          height={60}
          width={400}
        />
      </ModBox>
      <ModBox show={showCreatedScreen} {...styles.container} marginBottom={32} paddingHorizontal={32}>
        <AadharRedactionSubmit
          type={'AD_MAKER'}
          businessName={'NA'}
          handleParentBack={handleParentBack}
          applicationId={applicationId}
        />
      </ModBox>
    </>
  )
}

export default AadharRedaction

const mStyles = {
  container: {
    f: 1,
    bg: 'WHITE',
    p: 24,
  } as BoxProps,
  innerContainer: {
    f: 1,
    justify: 'center',
    align: 'center',
  } as BoxProps,
  searchContainer: {
    borderWidth: 1,
    p: 48,
    borderRadius: 4,
    borderColor: '#0070B61F' as ColorOptions,
    bg: '#0070B60A' as ColorOptions,
  } as BoxProps,
  textInputContainer: (error: boolean) =>
    ({
      flexDirection: 'row',
      borderColor: error ? 'ERROR' : 'BLUE_SHADE_PRIMARY',
      borderRadius: 4,
      borderWidth: 1,
      bg: 'WHITE',
    } as BoxProps),
  loadingContainer: { f: 1, flexDirection: 'row', justify: 'center', align: 'center', ph: 4 } as BoxProps,
  iconContainer: (isValidMid: boolean) =>
    ({
      bg: 'BLUE_SHADE_PRIMARY',
      h: 48,
      w: 48,
      underlayColor: 'TRANSPARENT',
      borderTopLeftRadius: 2,
      borderBottomLeftRadius: 2,
      borderTopRightRadius: 2,
      borderBottomRightRadius: 2,
      justify: 'center',
      disabled: !isValidMid,
      align: 'center',
    } as BoxProps),
}
